/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_ProgressInputs */

const en_upload_progress = /** @type {(inputs: Upload_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Progress`)
};

const fr_upload_progress = /** @type {(inputs: Upload_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression du téléversement`)
};

const de_upload_progress = /** @type {(inputs: Upload_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload-Fortschritt`)
};

const it_upload_progress = /** @type {(inputs: Upload_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento in corso`)
};

const ru_upload_progress = /** @type {(inputs: Upload_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ход загрузки`)
};

const es_upload_progress = /** @type {(inputs: Upload_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progreso de carga`)
};

const zh_cn2_upload_progress = /** @type {(inputs: Upload_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传进度`)
};

const ja_upload_progress = /** @type {(inputs: Upload_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップロードの進行状況`)
};

const hi_upload_progress = /** @type {(inputs: Upload_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपलोड प्रगति`)
};

const pt_pt2_upload_progress = /** @type {(inputs: Upload_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso do carregamento`)
};

/**
* | output |
* | --- |
* | "Upload Progress" |
*
* @param {Upload_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const upload_progress = /** @type {((inputs?: Upload_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_upload_progress(inputs)
	if (locale === "de") return de_upload_progress(inputs)
	if (locale === "it") return it_upload_progress(inputs)
	if (locale === "ru") return ru_upload_progress(inputs)
	if (locale === "es") return es_upload_progress(inputs)
	if (locale === "zh-CN") return zh_cn2_upload_progress(inputs)
	if (locale === "ja") return ja_upload_progress(inputs)
	if (locale === "hi") return hi_upload_progress(inputs)
	if (locale === "pt-PT") return pt_pt2_upload_progress(inputs)
	return en_upload_progress(inputs)
});